module.exports = __webpack_public_path__ + "71df7fefe1701aa79e9ca9424b8df7cb.jpg";